<ng-container *ngFor="let item of items">
  <ng-container *ngIf="item.visible | async">
    <div
      #toolItemEl
      class="tool-item"
      [ngClass]="{ 'highlight-mode': !!item.highlightMode }"
    >
      <ng-container *ngIf="!!(item.link && !item.disabled); else btnTpl">
        <a [href]="item.link" target="_blank">
          <ng-template [ngTemplateOutlet]="btnTpl"></ng-template>
        </a>
      </ng-container>

      <ng-template #btnTpl>
        <app-button
          class="tool-item-button"
          [buttonType]="item.selected ? 'primary' : 'normal'"
          shapeType="circle"
          [icon]="item.icon"
          [disabled]="!!item.disabled"
          (click)="item.onClick?.()"
        ></app-button>
      </ng-template>
    </div>

    <app-tooltip
      *ngIf="!!item.tooltip && !item.disabled"
      [target]="toolItemEl"
      verticalAlignment="top"
      horizontalAlignment="center"
    >
      {{ item.tooltip }}
    </app-tooltip>
  </ng-container>
</ng-container>
